import React from 'react';
import { RegularCheckBox } from '../../HouseStyle/Components/Checkboxes';

const CheckboxHeader = ({ currentItem, selectedIds, setSelectedIds, pk }) => {
  const currentPageIds = currentItem?.map(data => data[pk]) || [];
  const allCurrentPageSelected = currentPageIds.length > 0 && currentPageIds.every(id => selectedIds.includes(id));

  const handleCheckboxChange = (checked) => {
    const newIds = checked
      ? [...selectedIds, ...currentPageIds.filter(id => !selectedIds.includes(id))]
      : selectedIds.filter(id => !currentPageIds.includes(id));
    setSelectedIds(newIds);
  };

  return (
    <RegularCheckBox
      label=""
      value={allCurrentPageSelected}
      setValue={handleCheckboxChange}
    />
  );
};

export default CheckboxHeader;